var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIn(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 54,
    height: 40,
    fill: "none",
    viewBox: "0 0 54 40",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#f93",
    d: "M.7 0H54v13.3H.7z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M.7 13.3H54v13.4H.7z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#128807",
    d: "M.7 26.7H54V40H.7z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#008",
    d: "M27.3 25.3a5.3 5.3 0 1 0 0-10.6 5.3 5.3 0 0 0 0 10.6"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M27.3 24.7a4.7 4.7 0 1 0 0-9.4 4.7 4.7 0 0 0 0 9.4"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#008",
    d: "M27.3 21a1 1 0 1 0 0-2 1 1 0 0 0 0 2m4.7-.2a.2.2 0 1 0 0-.4.2.2 0 0 0 0 .4"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#008",
    d: "m27.3 24.7.2-2.8-.2-1.4-.1 1.4zm4.3-2.7a.2.2 0 1 0 .1-.4.2.2 0 0 0-.1.4m-5.5 2.5.9-2.7.2-1.3-.5 1.3zm4.8-1.5a.2.2 0 1 0 .3-.3.2.2 0 0 0-.3.3M25 24l1.5-2.3.6-1.2-.8 1zm5-.2a.2.2 0 1 0 .4-.2.2.2 0 0 0-.4.2m-6-.5 2.1-1.9.9-1-1.1.8zm4.9 1.1a.2.2 0 1 0 .4-.2.2.2 0 0 0-.4.2m-5.6-2.1 2.5-1.2 1-.8-1.2.5zm4.4 2.4a.2.2 0 1 0 .5-.1.2.2 0 0 0-.5 0m-4.9-3.4 2.8-.6 1.2-.5-1.3.2zm3.7 3.4a.2.2 0 1 0 .5 0 .2.2 0 0 0-.5 0M22.7 20l2.8.2 1.3-.2-1.3-.2zm2.6 4.2a.2.2 0 1 0 .5.2.2.2 0 0 0-.5-.2m-2.5-5.4 2.7.9 1.3.2-1.2-.5zm1.5 4.8a.2.2 0 1 0 .4.2.2.2 0 0 0-.4-.2m-1-5.9 2.3 1.5 1.3.5-1.1-.8zm.2 4.9a.2.2 0 1 0 .3.4.2.2 0 0 0-.3-.4"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#008",
    d: "m24 16.7 1.9 2 1 1-.8-1.1zm-1 4.9a.2.2 0 1 0 .1.4.2.2 0 0 0-.2-.4M25 16l1.3 2.5.8 1-.6-1.2zm-2.3 4.4a.2.2 0 1 0 0 .4.2.2 0 0 0 0-.4m3.4-4.9.6 2.7.5 1.3-.2-1.3zm-3.4 3.7a.2.2 0 1 0 0 .4.2.2 0 0 0 0-.4m4.6-3.9-.1 2.8.1 1.4.2-1.4zM23.1 18a.2.2 0 1 0-.2.4.2.2 0 0 0 .2-.4m5.4-2.5-.8 2.7-.2 1.3.5-1.3zM23.8 17a.2.2 0 1 0-.3.3.2.2 0 0 0 .3-.3m5.9-1L28 18.3l-.5 1.2.8-1zm-5 .2a.2.2 0 1 0-.4.2.2.2 0 0 0 .4-.2m5.9.5-2 1.9-.9 1 1-.8zm-4.8-1.1a.2.2 0 1 0-.5.2.2.2 0 0 0 .5-.2m5.6 2.1-2.5 1.2-1.1.8 1.2-.5zM27 15.3a.2.2 0 1 0-.5.1.2.2 0 0 0 .5 0m4.8 3.4-2.7.6-1.3.5 1.4-.2zm-3.6-3.4a.2.2 0 1 0-.5 0 .2.2 0 0 0 .5 0M32 20l-2.8-.2-1.3.2 1.3.2zm-2.7-4.2a.2.2 0 1 0-.4-.2.2.2 0 0 0 .4.2m2.5 5.4-2.6-.9-1.4-.2 1.3.5zm-1.4-4.8a.2.2 0 1 0-.4-.2.2.2 0 0 0 .4.2m1 5.9L29 20.8l-1.2-.5 1 .8zm-.2-4.9a.2.2 0 1 0-.3-.4.2.2 0 0 0 .3.4m-.6 5.9-1.8-2-1-1 .7 1.1zm1.1-4.9a.2.2 0 1 0-.1-.4.2.2 0 0 0 .1.4m-2 5.6-1.3-2.5-.8-1 .5 1.2zm2.3-4.4a.2.2 0 1 0 0-.4.2.2 0 0 0 0 .4m-3.5 4.9-.5-2.7-.5-1.3.2 1.3z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M.7 0H54v40H.7z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIn);
export default __webpack_public_path__ + "static/media/in.fc138951d215a5d51b0bad5c0c4a9674.svg";
export { ForwardRef as ReactComponent };